export const formatSexForUi = (value) => {
  if (value === 0) {
    return 'man';
  }

  return 'woman';
};
